import { Component, OnInit, Input} from '@angular/core';
import { HttpService } from '../../services/http.service';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material';






@Component({
  selector: 'app-doctyp8',
  templateUrl: './doctyp8.component.html',
  styleUrls: ['./doctyp8.component.scss']
})
export class Doctyp8Component implements OnInit {

  @Input() Document: any;

  beteiligung = [];
  wellen = [];

  today: number = Date.now();

  constructor(
    private http: HttpService,
    private router: Router,
    private snackBar: MatSnackBar
  ) {


   }

  ngOnInit() {








    if (this.Document['8_Wellenbeteiligung'] && this.Document['8_Wellenbeteiligung'] !== undefined ) {
      this.Document['8_Wellenbeteiligung'].forEach(element => {
            if (element['ps_doclink_probandeninteraktion']) {

                this.http.doctyp5(element.ps_doclink_probandeninteraktion).subscribe(doctyp5 => {
                  this.beteiligung.push(doctyp5);
                });
            }
      });
     }





     if (this.Document['8_ps_wellen'] && this.Document['8_ps_wellen'] !== undefined ) {
      this.Document['8_ps_wellen'].forEach(element => {
            if (element['ID']) {
                this.http.analyse(element['ID']).subscribe(analyse => {

                  this.wellen.push(analyse);


              });
            }
      });
     }



const collator = new Intl.Collator('de', { numeric: true, sensitivity: 'base' });
// TODO Sorting
// this.probanden.sort((a, b) => collator.compare(a['_source']['5_facet_us_welle'], b['_source']['5_facet_us_welle']));

// function sortTrackingNo(array, order) {
//   return array.sort(order === 'DESC'
//       ? function (b, a) {
//           a = a['_source']['5_us_welle'].content.slice(0, 3);
//           b = b['_source']['5_us_welle'].content.slice(0, 3);
//           return isNaN(b) - isNaN(a) || a > b || -(a < b);
//       }
//       : function (a, b) {
//           a = a['_source']['5_us_welle'].content.slice(0, 3);
//           b = b['_source']['5_us_welle'].content.slice(0, 3);
//           return isNaN(a) - isNaN(b) || a > b || -(a < b);
//       });
// }






const myArray = [
  { name: '1. Scene 1'},
  { name: '3. Scene 21'},
  { name: '4. Scene 10'},
  { name: '2. Scene 2'}
];

// sortTrackingNo(this.probanden, 'ASC');

console.log(this.wellen);
const sorted = myArray.sort((a, b) => collator.compare(a.name, b.name));

console.log(sorted);


  }

  link(id) {
    this.router.navigateByUrl('/' , {skipLocationChange: true}).then(() =>
    this.router.navigate(['/document/' + id]));
  }

  copy2Clipboard() {
    const element = document.getElementById('copy-cit');
    element.innerHTML = element.innerText || element.textContent;

    const ta = document.createElement('textarea');
    ta.value = element.innerHTML;
    document.body.appendChild(ta);
    ta.select();
    document.execCommand('copy');
    document.body.removeChild(ta);

    this.snackBar.open('In die Zwischenablage kopiert', 'schließen', {
      duration: 2000,
    });
  }




}



